import React from 'react'
import { LoadingButton, LoadingButtonProps } from '@mui/lab'
import useCancelButtonAction from '../hooks/useCancelButtonAction'

const isNativePolicy = `${window.location.href}${window.location.search}`.toLowerCase().includes('native')

const CancelButton: React.FC<Omit<LoadingButtonProps, 'loading' | 'onClick'>> = ({ sx, ...props }) => {
  const [isLoading, setIsLoading] = React.useState(false)

  const cancelButtonAction = useCancelButtonAction()

  const onClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      setIsLoading(true)

      cancelButtonAction()

      // I'm not clear why this is important, but it absolutely is SP: 13/01/2021
      event.preventDefault()
      event.stopPropagation()
    },
    [cancelButtonAction],
  )

  if (isNativePolicy) {
    return null
  }

  return (
    <LoadingButton
      loading={isLoading}
      sx={[
        {
          alignSelf: 'flex-start',
          minWidth: 0,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      onClick={onClick}
      variant="text"
      {...props}
    >
      Cancel
    </LoadingButton>
  )
}

export default CancelButton
